<template>
  <Modal
    :headline="`${$t('myVocabulary.editVocabulary', {vocabulary: topic})}`"
    :save-btn-disabled="!isValidVocabulary"
    :show-modal="showModal"
    :show-full-screen="true"
    :no-txt-padding="true"
    @save="saveVocabulary"
    @cancel="$emit('close:modal', false)">
    <v-row
      v-for="(item, index) in vocabulary.vocabularies"
      :key="`vocabulary-${index}`" class="px-6 py-4 mb-0 vocabulary-row" justify="center" align="end">
      <v-col cols="2" class="py-0">
        <v-checkbox :value="item" v-model="selectedItems" class="ma-0" />
      </v-col>
      <v-col cols="8" class="py-0">
        <v-text-field
          :tabindex="index + 1"
          :autofocus="index === vocabulary.vocabularies.length - 1"
          :label="`Learning (${userLanguages.learning.toUpperCase()})`"
          hide-details
          :lang="userLanguages.learning"
          autocomplete="off"
          v-model="item[userLanguages.learning]" />
        <GenderChooser
          :gender="item[`${userLanguages.learning}_gender`]"
          @select:gender="item[`${userLanguages.learning}_gender`] = $event" />
      </v-col>
      <v-col cols="2" class="py-0">
        <v-btn icon x-large @click="deleteVocabulary(index)" class="mb-2">
          <v-icon
            style="position: absolute; left: 0;"
            color="red">
            delete
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8" class="py-0 mb-1">
        <v-text-field
          :tabindex="index + 2"
          :label="`Base (${userLanguages.base.toUpperCase()})`"
          hide-details
          :lang="userLanguages.base"
          autocomplete="off"
          v-model="item[userLanguages.base]" />
      </v-col>
    </v-row>
    <v-row class="pa-6">
      <v-col cols="12">
        <v-btn
          block
          color="green"
          outlined
          @click="addVocabulary">
          <v-icon left small>add</v-icon>
          {{ $t('myVocabulary.addVocabulary') }}
        </v-btn>
      </v-col>
      <v-col cols="12">
        <MvMoveItems
          :vocabulary-list="vocabularyList"
          :vocabulary-list-keys="vocabularyListKeys"
          :selected-items="selectedItems"
          :total-items-length="vocabulary.vocabularies.length"
          :topic="topic"
          @updated:move-items="updatedMoveItems" />
      </v-col>
      <v-col cols="12" class="text-center">
        <ColorChooser
          :render-button="true"
          :color.sync="vocabulary.color" />
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@components/modal';
import { VOCABULARIES } from '@/config/firestore';
import mergeData from '@/mixins/firestore/mergeData';
import ColorChooser from '@components/color_chooser';
import GenderChooser from '@components/mv_manager/gender_chooser';
import MvMoveItems from './components/MvMoveItems';

export default {
  name: 'MvItems',
  components: {
    Modal,
    MvMoveItems,
    ColorChooser,
    GenderChooser,
  },
  mixins: [mergeData],
  props: {
    vocabularyList: {
      type: Array,
      required: true,
    },
    vocabularyListKeys: {
      type: Array,
      required: true,
    },
    propsVocabulary: {
      type: Object,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    vocabulary: {
      vocabularies: [],
    },
    selectedItems: [],
    topic: '',
    color: '',
  }),
  computed: {
    ...mapGetters('user', ['userLanguages']),

    isValidVocabulary() {
      return this.vocabulary.vocabularies
        .every((item) => item[this.userLanguages.base].length > 0 && item[this.userLanguages.learning].length > 0);
    },
  },
  methods: {
    addVocabulary() {
      this.vocabulary.vocabularies.push({
        [this.userLanguages.base]: '',
        [this.userLanguages.learning]: '',
      });
    },
    updatedMoveItems() {
      this.$emit('close:modal', false);
      this.$emit('updated:vocabulary');
    },
    async saveVocabulary() {
      this.$emit('close:modal', false);

      const vocabulary = this._.cloneDeep(this.vocabulary);
      const topicIndex = this._.findIndex(this.vocabularyList, {
        [this.userLanguages.base]: vocabulary[this.userLanguages.base],
      });

      vocabulary.color = this.color.length > 0 ? this.color : vocabulary.color;

      const vocabularyListKey = this.vocabularyListKeys[topicIndex];

      await this.mergeData(VOCABULARIES, { [vocabularyListKey]: vocabulary });

      this.$emit('updated:vocabulary');
    },
    deleteVocabulary(index) {
      this.$delete(this.vocabulary.vocabularies, index);
    },
  },
  watch: {
    async showModal() {
      if (this.showModal) {
        this.vocabulary = this._.cloneDeep(this.propsVocabulary);
        this.topic = this.vocabulary[this.userLanguages.base];
        this.selectedItems = [];
      }
    },
  },
};
</script>

<style lang="scss">
.vocabulary-row {
  &:nth-child(even) {
    background: #efefef;
    border-radius: 10px;
    margin-bottom: 25px;
  }
}
</style>
